import { render, staticRenderFns } from "./addTable.vue?vue&type=template&id=00aeaa68&scoped=true&"
import script from "./addTable.vue?vue&type=script&lang=js&"
export * from "./addTable.vue?vue&type=script&lang=js&"
import style0 from "./addTable.vue?vue&type=style&index=0&id=00aeaa68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aeaa68",
  null
  
)

export default component.exports